import { Alert } from "@mantine/core";
import ReactMarkdown from "react-markdown";
import { AlertPresets } from "../../../../../mantine/mantinePresets";
import { SiteName } from "../../../../../utils/enums";
import { Extendable } from "../../../../Extendable/Extendable";

declare const SITE_NAME: SiteName;

function getFormulaInfoMarkdown() {
  let supportEmail = "";
  if (SITE_NAME === SiteName.Optinode) supportEmail = "support@node.energy";
  if (SITE_NAME === SiteName.Smarendo) supportEmail = "smarendo@node.energy";
  const supportContact = supportEmail
    ? `[${supportEmail}](mailto:${supportEmail})`
    : "unseren Support.";

  // TODO in https://node-energy.atlassian.net/browse/WUP-8864: add this extra text as soon templates are actually available for users
  //   return `Wählen Sie im Feld "Formelvorlage", die Formel aus, die der Angabe in Ihrem Vermarktungsvertrag entspricht.

  // Die richtige Formel ist nicht dabei?\\
  // Kein Problem, erstellen Sie die passende Formel in unserem Formelfeld. Gehen Sie dabei wie folgt vor:

  return `Erstellen Sie die passende Formel in unserem Formelfeld. Gehen Sie dabei wie folgt vor:

1. **Variablen auswählen:** Wählen Sie zuerst die passenden Variablen aus, z. B. "GesamtStrommenge" und "Spotmarktwert".
2. **Operatoren verwenden:** Kombinieren Sie die ausgewählten Variablen mit den Rechenzeichen "+", "-", "*", "/".
3. **Funktionen anwenden:** Verwenden Sie "Wenn", "Min", "Max" für intelligente Berechnungen. Beispiel: "Wenn(Spotmarktpreis > 100, "0,04", "0,02")".

Bitte beachten Sie dabei:
- Im Formelfeld können Sie zwischen den Klammern auf weitere Variablen oder Operatoren klicken und Zahlen eingeben, um die Formel zu erstellen.
- Überprüfen Sie, ob am Ende ein Wert in mit der Einheit "€" steht.
- Es ist möglich, bereits in opti.node hinterlegte Formeln zu kopieren.

Sollten Sie Hilfe bei der Eingabe benötigen, dann wenden Sie sich bitte mit Ihrem Vermarktungsvertrag zur Hand an ${supportContact}.`;
}

function FormulaFieldInfo() {
  return (
    <Alert
      color={AlertPresets.info.color}
      icon={AlertPresets.info.icon}
      mb="md"
      mt="xs"
      title="So nutzen Sie das Formel-Eingabefeld:"
    >
      <Extendable buttonProps={{ c: "blue" }}>
        <ReactMarkdown>{getFormulaInfoMarkdown()}</ReactMarkdown>
      </Extendable>
    </Alert>
  );
}

export { FormulaFieldInfo };
